// src/components/Footer/Footer.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const location = useLocation();
  const path = location.pathname;
  
  // Only show about link on homepage (/) or profile page (/profile)
  const showAboutLink = path === '/' || path === '/profile';
  
  return (
    <footer className="site-footer">
      <div className="footer-content">
        {showAboutLink && (
          <p className="footer-links">
            <Link to="/about" className="footer-link">about isLike</Link>
          </p>
        )}

        <p className="footer-attribution">
          Some location data ©2025 Google – used under Google Maps/Places API terms.
        </p>
      </div>
    </footer>
  );
}

export default Footer;